import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import baseUrl from "../../utilities/baseUrl";
import LoadingButton from "../Loading/LoadingButton";

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.label]
 * @param {import("axios").AxiosRequestConfig} [props.config]
 */
export default function ExcelDownload({
  className = "",
  label = "دانلود اکسل",
  config = {},
}) {
  const token = localStorage.getItem("token");

  const { isPending, mutate } = useMutation({
    mutationKey: ["excel-download"],
    mutationFn: () =>
      axios
        .request({
          headers: {
            Authorization: "Bearer " + token,
          },
          responseType: "blob",
          baseURL: baseUrl,
          ...config,
        })
        .then(res => res.data),

    onSuccess: data => {
      const href = URL.createObjectURL(data);

      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "file_" + new Date().toLocaleString());
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },

    onError: async error => {
      let message = "";

      try {
        const object = JSON.parse(await error.response.data.text());
        message = object.message;
      } catch (error) {
        message = "در ارتباط با سرور با خطا مواجه شدیم";
      }

      Swal.fire({
        icon: "error",
        text: message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    },
  });

  if (isPending) {
    return (
      <LoadingButton
        center
        className={"btn-success " + className}
        title="در حال دانلود"
      />
    );
  }

  return (
    <Button className={"btn-success " + className} onClick={mutate}>
      {label}
    </Button>
  );
}
